module.exports = __webpack_public_path__ + "static/media/Hatchback.1229430b.svg";